import type { Nullable, ProductKind } from '@iheartjane/types';
import { isProductKind } from '@iheartjane/types';

import type { ProductFacets, FilterSelectItem } from '@jane/search/data-access';
import type { Store } from '@jane/shared/types';

import { customSubcategoryLabel } from '../customSubcategoryLabel/customSubcategoryLabel';

type Subcategories = Partial<Record<ProductKind, FilterSelectItem[]>>;

export const getSubcategories = (
  facets: ProductFacets,
  store: Store,
  mainCategory?: Nullable<ProductKind>
) => {
  const rootTypes = facets.root_types ?? {};

  return Object.entries(rootTypes).reduce<Subcategories>(
    (acc, [rootType, count]) => {
      const [category, subcategory] = rootType.split(':');

      if (
        isProductKind(category) &&
        subcategory &&
        (!mainCategory || category === mainCategory)
      ) {
        acc[category] ??= [];
        acc[category]?.push({
          count,
          label: customSubcategoryLabel({
            store,
            subcategory: { value: rootType, label: subcategory },
          }),
          value: rootType,
        });
      }

      return acc;
    },
    {}
  );
};
